import { ToastContainer } from "react-toastify";
import Main from "./components/Routes/Main";

function App() {
  return (
    <div>
      <Main />
       <ToastContainer />
    </div>
  );
}

export default App;
